"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.whiteboardBytes = exports.emptyWhiteboardDocument = exports.PERSONAL_WHITEBOARD_SLOTS = exports.WHITEBOARD_SLOTS = exports.WHITEBOARD_CELL_SIZE = exports.WHITEBOARD_GRID_SIZE = exports.WHITEBOARD_WIDTHS = exports.WHITEBOARD_COLORS = exports.WHITEBOARD_MAX_OBJECTS = exports.WHITEBOARD_MAX_BYTES = exports.WHITEBOARD_VERSION = void 0;
exports.isWhiteboardObject = isWhiteboardObject;
exports.isWhiteboardDocument = isWhiteboardDocument;
exports.counterPosition = counterPosition;
exports.snappedCounter = snappedCounter;
exports.WHITEBOARD_VERSION = 1;
exports.WHITEBOARD_MAX_BYTES = 2 * 1024 * 1024;
exports.WHITEBOARD_MAX_OBJECTS = 2000;
exports.WHITEBOARD_COLORS = ["#2f3a40", "#1f6a4a", "#1769aa", "#c0392b"];
exports.WHITEBOARD_WIDTHS = [3, 6, 10];
exports.WHITEBOARD_GRID_SIZE = 500;
exports.WHITEBOARD_CELL_SIZE = 50;
exports.WHITEBOARD_SLOTS = 5;
exports.PERSONAL_WHITEBOARD_SLOTS = 20;
const emptyWhiteboardDocument = () => ({ version: 1, width: 1600, height: 1000, objects: [] });
exports.emptyWhiteboardDocument = emptyWhiteboardDocument;
const object = (v) => Boolean(v && typeof v === "object" && !Array.isArray(v));
const bounded = (v, max) => typeof v === "number" && Number.isFinite(v) && v >= 0 && v <= max;
const whiteboardBytes = (value) => new TextEncoder().encode(JSON.stringify(value)).length;
exports.whiteboardBytes = whiteboardBytes;
function isWhiteboardObject(v) {
    if (!object(v) || typeof v.id !== "string" || !/^[a-zA-Z0-9-]{1,64}$/.test(v.id) || v.id in Object.prototype
        || !bounded(v.x, 1600) || !bounded(v.y, 1000) || typeof v.locked !== "boolean")
        return false;
    const keys = ["id", "x", "y", "locked", "type"];
    if (v.type === "stroke") {
        keys.push("color", "width", "points");
        if (!exports.WHITEBOARD_COLORS.includes(v.color) || !exports.WHITEBOARD_WIDTHS.includes(v.width)
            || !Array.isArray(v.points) || v.points.length < 2 || v.points.length % 2 || v.points.length > 100000
            || !v.points.every((p, i) => bounded(p, i % 2 ? 1000 : 1600)))
            return false;
    }
    else if (v.type === "text") {
        keys.push("text", "color");
        if (typeof v.text !== "string" || v.text.length > 2000 || !exports.WHITEBOARD_COLORS.includes(v.color))
            return false;
    }
    else if (v.type === "stick") {
        keys.push("rotation");
        if (![0, 90, 180, 270].includes(v.rotation) || !bounded(v.x, 1584) || !bounded(v.y, 984))
            return false;
    }
    else if (v.type === "counter") {
        keys.push("color", "cell");
        if (!["red", "blue"].includes(v.color) || !(v.cell === null || Number.isInteger(v.cell) && bounded(v.cell, 99)))
            return false;
    }
    else if (v.type === "hundred-grid") {
        keys.push("showNumbers");
        if (typeof v.showNumbers !== "boolean" || !bounded(v.x, 1100) || !bounded(v.y, 500))
            return false;
    }
    else
        return false;
    return Object.keys(v).every((key) => keys.includes(key));
}
function isWhiteboardDocument(v) {
    if (!object(v) || v.version !== 1 || v.width !== 1600 || v.height !== 1000 || !Array.isArray(v.objects)
        || Object.keys(v).some((key) => !["version", "width", "height", "objects"].includes(key))
        || v.objects.length > exports.WHITEBOARD_MAX_OBJECTS || !v.objects.every(isWhiteboardObject))
        return false;
    const objects = v.objects;
    const grid = objects.find((entry) => entry.type === "hundred-grid");
    return new Set(objects.map((entry) => entry.id)).size === objects.length
        && objects.filter((entry) => entry.type === "hundred-grid").length <= 1
        && objects.every((entry) => entry.type !== "counter" || entry.cell === null || Boolean(grid))
        && (0, exports.whiteboardBytes)(v) <= exports.WHITEBOARD_MAX_BYTES;
}
function counterPosition(counter, grid) {
    return counter.cell !== null && grid
        ? { x: grid.x + (counter.cell % 10 + 0.5) * exports.WHITEBOARD_CELL_SIZE, y: grid.y + (Math.floor(counter.cell / 10) + 0.5) * exports.WHITEBOARD_CELL_SIZE }
        : { x: counter.x, y: counter.y };
}
function snappedCounter(counter, objects) {
    const grid = objects.find((entry) => entry.type === "hundred-grid");
    const inside = grid && counter.x >= grid.x && counter.y >= grid.y && counter.x < grid.x + 500 && counter.y < grid.y + 500;
    const snapped = { ...counter, cell: inside ? Math.floor((counter.y - grid.y) / 50) * 10 + Math.floor((counter.x - grid.x) / 50) : null };
    return { ...snapped, ...counterPosition(snapped, grid) };
}
//# sourceMappingURL=whiteboard.js.map